import type {
  ClinicInvoiceBillingType,
  ClinicInvoiceServiceType,
} from 'infrastructure/enums';
import type { IClinicInvoice } from 'infrastructure/interfaces';

export class ClinicInvoice {
  guid: string;
  code: string;
  name?: string;
  description: string;
  price: number;
  status: boolean;
  serviceType: ClinicInvoiceServiceType;
  billingType: ClinicInvoiceBillingType;

  private _originalState: IClinicInvoice;

  constructor(data: IClinicInvoice) {
    this.guid = data.guid;
    this.code = data.code;
    this.name = data.name;
    this.description = data.description;
    this.price = data.price;
    this.status = data.status;
    this.serviceType = data.serviceType;
    this.billingType = data.billingType;

    this._originalState = structuredClone(data);
  }

  saveChanges(data: ClinicInvoice) {
    this.name = data.name;
    this.description = data.description;
    this.price = data.price;
    this.status = data.status;
    this.serviceType = data.serviceType;
    this.billingType = data.billingType;
  }

  toggleStatus(val: boolean) {
    this.status = val;
  }

  reset() {
    this.code = this._originalState.code;
    this.name = this._originalState.name;
    this.description = this._originalState.description;
    this.price = this._originalState.price;
    this.status = this._originalState.status;
    this.serviceType = this._originalState.serviceType;
    this.billingType = this._originalState.billingType;
  }
}
